import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveWinnersDrops } from "./drops/WaveWinnersDrops";
import { WaveWinnersPodium } from "./podium/WaveWinnersPodium";
import { WaveWinnersTimeline } from "./WaveWinnersTimeline";
import { FULL_APPROVAL_WAVE_DECISIONS_PAGE_SIZE, useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { WaveWinnersApprovalError } from "./WaveWinnersApprovalError";
import { getApprovedWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
interface WaveWinnersProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveWinners: React.FC<WaveWinnersProps> = t0 => {
  const $ = _c(44);
  const {
    wave,
    onDropClick
  } = t0;
  const {
    decisions: t1,
    isQuorumWave
  } = useWave(wave);
  const {
    multiDecision
  } = t1;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const {
    winnersViewStyle
  } = useLayout();
  const t2 = isApproveWave ? FULL_APPROVAL_WAVE_DECISIONS_PAGE_SIZE : undefined;
  let t3;
  if ($[0] !== isApproveWave || $[1] !== t2 || $[2] !== wave) {
    t3 = {
      waveId: wave.id,
      wave,
      enabled: true,
      loadAllPages: isApproveWave,
      pageSize: t2
    };
    $[0] = isApproveWave;
    $[1] = t2;
    $[2] = wave;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    decisionPoints,
    isFetching,
    isLoadingAllPages,
    isLoadingAllPagesError,
    refetch,
    fetchNextPage,
    hasNextPage
  } = useWaveDecisions(t3);
  const isDecisionsLoading = isApproveWave ? isLoadingAllPages : isFetching;
  let t4;
  if ($[4] !== decisionPoints) {
    t4 = getApprovedWaveDecisionWinners(decisionPoints);
    $[4] = decisionPoints;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const approvedWinners = t4;
  const contentPresentation = isQuorumWave ? "quorumCompact" : undefined;
  let t5;
  if ($[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== refetch) {
    t5 = () => {
      if (hasNextPage) {
        fetchNextPage();
        return;
      }
      refetch();
    };
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = refetch;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleApprovalWinnersRetry = t5;
  let winnersContent;
  if (isApproveWave && isLoadingAllPagesError) {
    let t6;
    if ($[10] !== handleApprovalWinnersRetry) {
      t6 = <div className="tw-mt-2 tw-flex-grow tw-pb-6 lg:tw-pr-2"><WaveWinnersApprovalError onRetry={handleApprovalWinnersRetry} /></div>;
      $[10] = handleApprovalWinnersRetry;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    winnersContent = t6;
  } else {
    if (isApproveWave) {
      let t6;
      if ($[12] !== approvedWinners || $[13] !== contentPresentation || $[14] !== isDecisionsLoading || $[15] !== onDropClick || $[16] !== wave) {
        t6 = <div className="tw-mt-2 tw-flex-grow tw-space-y-2 tw-pb-6 lg:tw-pr-2"><WaveWinnersDrops wave={wave} onDropClick={onDropClick} winners={approvedWinners} isLoading={isDecisionsLoading} isApprovalWave={true} emptyMessage="No drops approved yet" contentPresentation={contentPresentation} /></div>;
        $[12] = approvedWinners;
        $[13] = contentPresentation;
        $[14] = isDecisionsLoading;
        $[15] = onDropClick;
        $[16] = wave;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      winnersContent = t6;
    } else {
      if (multiDecision) {
        let t6;
        if ($[18] !== contentPresentation || $[19] !== decisionPoints || $[20] !== isDecisionsLoading || $[21] !== onDropClick || $[22] !== wave) {
          t6 = <WaveWinnersTimeline onDropClick={onDropClick} decisionPoints={decisionPoints} wave={wave} isLoading={isDecisionsLoading} contentPresentation={contentPresentation} />;
          $[18] = contentPresentation;
          $[19] = decisionPoints;
          $[20] = isDecisionsLoading;
          $[21] = onDropClick;
          $[22] = wave;
          $[23] = t6;
        } else {
          t6 = $[23];
        }
        winnersContent = t6;
      } else {
        let t6;
        if ($[24] !== decisionPoints[0]?.winners) {
          t6 = decisionPoints[0]?.winners ?? [];
          $[24] = decisionPoints[0]?.winners;
          $[25] = t6;
        } else {
          t6 = $[25];
        }
        let t7;
        if ($[26] !== isDecisionsLoading || $[27] !== onDropClick || $[28] !== t6) {
          t7 = <WaveWinnersPodium onDropClick={onDropClick} winners={t6} isLoading={isDecisionsLoading} />;
          $[26] = isDecisionsLoading;
          $[27] = onDropClick;
          $[28] = t6;
          $[29] = t7;
        } else {
          t7 = $[29];
        }
        let t8;
        if ($[30] !== decisionPoints[0]?.winners) {
          t8 = decisionPoints[0]?.winners ?? [];
          $[30] = decisionPoints[0]?.winners;
          $[31] = t8;
        } else {
          t8 = $[31];
        }
        let t9;
        if ($[32] !== contentPresentation || $[33] !== isDecisionsLoading || $[34] !== onDropClick || $[35] !== t8 || $[36] !== wave) {
          t9 = <WaveWinnersDrops wave={wave} onDropClick={onDropClick} winners={t8} isLoading={isDecisionsLoading} contentPresentation={contentPresentation} />;
          $[32] = contentPresentation;
          $[33] = isDecisionsLoading;
          $[34] = onDropClick;
          $[35] = t8;
          $[36] = wave;
          $[37] = t9;
        } else {
          t9 = $[37];
        }
        let t10;
        if ($[38] !== t7 || $[39] !== t9) {
          t10 = <div className="tw-mt-2 tw-flex-grow tw-space-y-2 tw-pb-6 lg:tw-pr-2">{t7}{t9}</div>;
          $[38] = t7;
          $[39] = t9;
          $[40] = t10;
        } else {
          t10 = $[40];
        }
        winnersContent = t10;
      }
    }
  }
  let t6;
  if ($[41] !== winnersContent || $[42] !== winnersViewStyle) {
    t6 = <div className="tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 lg:tw-space-y-6" style={winnersViewStyle}>{winnersContent}</div>;
    $[41] = winnersContent;
    $[42] = winnersViewStyle;
    $[43] = t6;
  } else {
    t6 = $[43];
  }
  return t6;
};